import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { SiaBaseEditorSignalComponent } from '../sia-base-editor/sia-base-editor-signal.component';
import { SiaGoogleSearchButtonComponent } from '../sia-google-search-button/sia-google-search-button.component';
import { SiaTextBoxComponent } from '../sia-text-box/sia-text-box.component';
@Component({
  selector: 'sia-google-search-box',
  templateUrl: './sia-google-search-box.component.html',
  styleUrls: ['./sia-google-search-box.component.scss'],
  standalone: true,
  imports: [SiaTextBoxComponent, SiaGoogleSearchButtonComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SiaGoogleSearchBoxComponent extends SiaBaseEditorSignalComponent {
  readonly urlPattern = input<string | undefined>();
  readonly guid = input<string | null | undefined>();
}
